import script from "./UserDetailsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailsPanel.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailsPanel.vue?vue&type=style&index=0&id=04ca64a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ca64a6"]])

export default __exports__